<template>
  <v-card class="mx-auto" flat>
    <v-card-text>
      <v-container>
        <v-alert v-show="error" type="error" dense v-html="error" />
        <div>
          <h2 class="black--text">Lengkapi Formulir Data Akun dibawah ini</h2>
        </div>
        <v-row class="mt-2">
          <v-col cols="12">
            <span class="px-0 grey--text text--darken-1" style="height: 24px">
              Apakah sudah memiliki Akun SIMPKB ? <span class="red--text">*</span>
            </span>
            <v-radio-group v-model="isAkunSimpkb" row hide-details class="mt-0">
              <v-radio value="1">
                <template v-slot:label>
                  <span class="body-2 black--text">
                    <span class="green--text mr-1 font-weight-medium">Ya,</span> memiliki Akun SIMPKB
                  </span>
                </template>
              </v-radio>
              <v-radio value="2">
                <template v-slot:label>
                  <span class="body-2 black--text">
                    <span class="orange--text mr-1 font-weight-medium">Tidak,</span> belum memiliki Akun SIMPKB
                  </span>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row v-if="isAkunSimpkb === '1'" class="mt-5">
          <v-col cols="12">
            <v-row>
              <v-col cols="12" class="py-0">
                <span class="pa-0 grey--text text--darken-1" style="height: 24px">
                  Akun SIMPKB <span class="red--text">*</span>
                </span>
              </v-col>
              <v-col cols="10" md="6" class="py-0">
                <v-text-field
                  v-model="keyword"
                  dense
                  outlined
                  hide-details
                  placeholder="Tuliskan Akun SIMPKB"
                  :disabled="isChecked"
                />
              </v-col>
              <v-col cols="2" class="pa-0 my-auto">
                <v-btn depressed color="secondary" @click="onCheckAkun"> {{ isChecked ? 'Ganti' : 'Cek' }} Akun </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row :class="[isChecked && $isObject(akun) ? 'mt-10' : 'mt-5']">
          <v-col v-if="isAkunSimpkb === '1' && isChecked && $isObject(akun)" cols="12">
            <base-form-generator :schema="schemaAkun" v-model="form" />
          </v-col>
          <v-col v-else-if="isAkunSimpkb === '2'" cols="12">
            <base-form-generator :schema="schemaInput" v-model="form" />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import BaseFormGenerator from '@/components/base/BaseFormGenerator';
import { mapActions } from 'vuex';
export default {
  components: { BaseFormGenerator },
  props: {
    initValue: {
      default: () => null,
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      id: null,
      isAkunSimpkb: null,
      isChecked: false,
      keyword: null,
      error: null,
      akun: {},
      form: {},
    };
  },
  computed: {
    configs() {
      const M_PROPINSI = (this.masters && this.masters['propinsi']) || {};
      const M_KOTA = (this.masters && this.masters['kota']) || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: ['k_propinsi', 'k_kota'],
        label: ['Provinsi', 'Kota/Kabupaten'],
        options: [M_PROPINSI, M_KOTA],
        grid: [
          { cols: 12, lg: 6 },
          { cols: 12, lg: 6 },
        ],
        disabled: [],
      };
    },

    schemaAkun() {
      return [
        {
          type: 'textView',
          label: `Akun SIMPKB`,
          labelColor: 'grey',
          value: this.keyword,
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Nama Lengkap`,
          labelColor: 'grey',
          value: this.akun.nama || '-',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Tempat Lahir`,
          labelColor: 'grey',
          value: this.akun.tmp_lahir || '-',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Tanggal Lahir`,
          labelColor: 'grey',
          value: this.$localDate(this.akun.tgl_lahir) || '-',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Jenis Kelamin`,
          labelColor: 'grey',
          value: this.akun.kelamin ? (this.akun.kelamin === 'L' ? 'Laki - laki' : 'Perempuan') : '-',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Alamat`,
          labelColor: 'grey',
          value: this.akun.alamat || '-',
          grid: { cols: 12 },
        },
        {
          type: 'textView',
          label: `Provinsi`,
          labelColor: 'grey',
          value: this.$getDeepObj(this.akun, 'm_propinsi.keterangan') || '-',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'textView',
          label: `Kota`,
          labelColor: 'grey',
          value: this.$getDeepObj(this.akun, 'm_kota.keterangan') || '-',
          grid: { cols: 12, md: 6 },
        },
        {
          type: 'VTextField',
          name: 'no_wa',
          label: 'Nomor Telepon (terhubung WhatsApp)',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          mask: '###############',
          outlined: true,
          dense: true,
          singleLine: true,
          required: true,
        },
      ];
    },

    schemaInput() {
      return [
        {
          type: 'VTextField',
          name: 'nama',
          label: 'Nama Lengkap',
          labelColor: 'grey',
          hint: '',
          required: true,
          grid: { cols: 12, lg: 6 },
          outlined: true,
          singleLine: true,
          dense: true,
        },
        {
          type: 'VRadio',
          name: 'kelamin',
          label: 'Jenis Kelamin',
          labelColor: 'grey',
          hint: 'wajib diisi',
          items: [
            { value: 'L', text: 'Laki-Laki' },
            { value: 'P', text: 'Perempuan' },
          ],
          required: true,
          hideDetails: false,
          outlined: true,
          dense: true,
          row: true,
          singleLine: false,
          grid: { cols: 12, lg: 6 },
        },
        {
          type: 'VTextField',
          name: 'tmp_lahir',
          label: 'Tempat Lahir',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12, lg: 6 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
        {
          type: 'VDatePicker',
          name: 'tgl_lahir',
          label: 'Tanggal Lahir',
          hint: 'wajib diisi',
          required: true,
          hideDetails: false,
          outlined: true,
          dense: true,
          singleLine: true,
          grid: { cols: 12, lg: 6 },
          labelColor: 'grey',
        },
        {
          type: 'VTextarea',
          name: 'alamat',
          label: 'Alamat',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
          autoGrow: true,
        },
        {
          type: 'cascade',
          labelColor: 'grey',
          configs: this.configs,
          grid: { cols: 12 },
        },
        {
          type: 'VTextField',
          name: 'no_wa',
          label: 'Nomor Telepon (terhubung WhatsApp)',
          labelColor: 'grey',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 6 },
          mask: '###############',
          outlined: true,
          dense: true,
          singleLine: true,
          required: true,
        },
        {
          type: 'VTextField',
          name: 'email',
          label: `Alamat Surel`,
          labelColor: 'grey',
          hideDetails: false,
          placeholder: 'Alamat Surel',
          hint: 'wajib diisi',
          grid: { cols: 12, lg: 6 },
          required: true,
          outlined: true,
          dense: true,
          singleLine: true,
        },
      ];
    },
  },
  methods: {
    ...mapActions('pip', ['lookup']),

    reset() {
      this.$set(this, 'id', null);
      this.$set(this, 'isAkunSimpkb', null);
      this.$set(this, 'form', {});
    },

    initForm() {},

    getValue() {
      if (this.isAkunSimpkb === '1') {
        this.form['ptk_id'] = this.akun.ptk_id;
      } else if (this.isAkunSimpkb === '2') {
        this.form['is_baru'] = 1;
      }

      return this.form;
    },

    onChangeStatus(status) {
      this.$set(this, 'isAkunSimpkb', status);
      this.$set(this, 'form', {});
      this.$set(this, 'keyword', null);
      this.isChecked = false;
      this.data = {};
    },

    onCheckAkun() {
      if (!this.keyword) {
        return;
      }

      if (this.isChecked) {
        this.isChecked = false;
        return;
      }

      this.$set(this, 'form', {});
      this.$set(this, 'error', null);
      this.lookup({ params: { keyword: this.keyword || '' } }).then((data) => {
        this.akun = data;
        this.isChecked = this.$isObject(data);
        if (!this.isChecked) {
          this.error = `Akun SIMPKB <strong>${this.keyword}</strong> tidak ditemukan`;
        }
      });
    },
  },
  watch: {
    initValue: 'initForm',
    isAkunSimpkb: 'onChangeStatus',
  },
};
</script>
